import React from 'react';
import Data from './Json/Home.json';
import Header from './components/Header/Index';
import Footer from './components/Footer/Index';

const ThankYou = () => {
  const lpParam = new URLSearchParams(window.location.search).get('lp');
  const isSscamasa = lpParam === 'sscamasa';
  const targetUrl = isSscamasa
    ? 'https://www.sscamasa.in/'
    : 'https://ssgroup-india.com/';

  return (
    <>
      <Header Data={Data.header} />
      <div className="flex flex-wrap w-full primary-bg lp-thankyou-page">
        <div className="slideCenter position-center white-space-wrap bg-black-500 p-4 max-width-100">
          <div className="w-full text-center md:w-[520px] m-auto">
            <div className="lp-thankyou-check" aria-hidden="true" />
            <h2 className="text-white text-3xl font-semibold mb-2">Thank You!</h2>
            <p className="text-white mb-4">
              Your request has been received. Our team will call you back shortly.
            </p>

            <a
              href={targetUrl}
              className="text-white underline mt-4 inline-block"
              target="_blank"
              rel="noopener noreferrer"
            >
              Go to Homepage →
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ThankYou;
